import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Instagram } from 'lucide-react';
import { Button } from './ui/button';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-primary text-primary-foreground">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* About Section */}
          <div>
            <h3 className="text-xl font-bold mb-4">Sadie's Mission Dog Boarding</h3>
            <p className="text-primary-foreground/90 mb-4">
              Providing loving, professional care for your furry family members in Mission, BC.
            </p>
            <div className="mb-4">
              <a
                href="https://instagram.com/sadiesmission_bc"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center space-x-2 px-4 py-2 rounded-lg bg-primary-foreground/10 hover:bg-primary-foreground/20 transition-colors"
              >
                <Instagram className="h-5 w-5" />
                <span className="font-medium">Follow us on Instagram</span>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-xl font-bold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-primary-foreground/90 hover:text-primary-foreground transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-primary-foreground/90 hover:text-primary-foreground transition-colors">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/photo-updates" className="text-primary-foreground/90 hover:text-primary-foreground transition-colors">
                  Photo Updates
                </Link>
              </li>
              <li>
                <Link to="/booking" className="text-primary-foreground/90 hover:text-primary-foreground transition-colors">
                  Book Now
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-primary-foreground/90 hover:text-primary-foreground transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-primary-foreground/90 hover:text-primary-foreground transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-xl font-bold mb-4">Contact Us</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <MapPin className="h-5 w-5 mt-0.5 flex-shrink-0" />
                <span className="text-primary-foreground/90">
                  Stave Falls - 12320 Bell Street<br />
                  Mission, BC
                </span>
              </li>
              <li>
                <a href="tel:6042186742" className="flex items-center space-x-3 text-primary-foreground/90 hover:text-primary-foreground transition-colors">
                  <Phone className="h-5 w-5 flex-shrink-0" />
                  <span>604-218-6742</span>
                </a>
              </li>
              <li>
                <a href="mailto:JDecker@sadiesmission.com" className="flex items-center space-x-3 text-primary-foreground/90 hover:text-primary-foreground transition-colors">
                  <Mail className="h-5 w-5 flex-shrink-0" />
                  <span>JDecker@sadiesmission.com</span>
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-8 pt-8 border-t border-primary-foreground/20 text-center text-primary-foreground/80 text-sm">
          <p>&copy; {currentYear} Sadie's Mission Dog Boarding. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
